/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LocalityType {
  All = 'All',
  Digital = 'Digital',
  Physical = 'Physical'
}
